const config = {
    apiBaseUrl: process.env.REACT_APP_ROOT_URL,
    razorpay: process.env.REACT_APP_razorpay,
    cashfree: process.env.REACT_APP_cashfree
  };
  
  export default config;
  